// DOMAIN
import { MaritalStatusEntity } from '@/modules/onboarding/catalogs/marital-status/domain/entities/marital-status-entity';

export class MaritalStatusState {
  loaded = false;

  items: Array<MaritalStatusEntity> = [];
}
